import React, { useState, useEffect } from 'react';

/* ── Neon color palette for sidebar sections ── */
const NEON = {
  cyan:    '#00F0FF',
  magenta: '#FF00E5',
  lime:    '#39FF14',
  orange:  '#FF6B00',
  violet:  '#BF5FFF',
  pink:    '#FF2D7B',
  teal:    '#00E5A0',
  blue:    '#3B8FF4',
  yellow:  '#FFE500',
  coral:   '#FF4F4F',
  mint:    '#00FFC8',
  gold:    '#FFB300',
  sky:     '#00BFFF',
  rose:    '#FF6B9D',
};

/* ── SVG Icon factory (18×18 monochrome stroke icons) ── */
const I = (paths, color) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {paths}
  </svg>
);

/* ── Icon definitions by key ── */
const ICONS = {
  // Self Service – Cyan
  home:        (c) => I(<><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>, c),
  // Dashboards – Magenta
  barChart:    (c) => I(<><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></>, c),
  trendUp:     (c) => I(<><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>, c),
  users:       (c) => I(<><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>, c),
  dollarSign:  (c) => I(<><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></>, c),
  // CRM – Lime
  clipboard:   (c) => I(<><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></>, c),
  target:      (c) => I(<><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></>, c),
  columns:     (c) => I(<><rect x="4" y="3" width="16" height="18" rx="2"/><line x1="12" y1="3" x2="12" y2="21"/></>, c),
  // Customers – Orange
  userGroup:   (c) => I(<><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>, c),
  // Sales – Violet
  fileText:    (c) => I(<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>, c),
  calculator:  (c) => I(<><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="8" y2="10.01"/><line x1="12" y1="10" x2="12" y2="10.01"/><line x1="16" y1="10" x2="16" y2="10.01"/><line x1="8" y1="14" x2="8" y2="14.01"/><line x1="12" y1="14" x2="12" y2="14.01"/><line x1="16" y1="14" x2="16" y2="14.01"/><line x1="8" y1="18" x2="16" y2="18"/></>, c),
  send:        (c) => I(<><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>, c),
  filePen:     (c) => I(<><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></>, c),
  // HCM – Pink
  userCheck:   (c) => I(<><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></>, c),
  userPlus:    (c) => I(<><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></>, c),
  calendar:    (c) => I(<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>, c),
  orgTree:     (c) => I(<><circle cx="12" cy="5" r="3"/><line x1="12" y1="8" x2="12" y2="14"/><circle cx="6" cy="19" r="3"/><circle cx="18" cy="19" r="3"/><line x1="12" y1="14" x2="6" y2="16"/><line x1="12" y1="14" x2="18" y2="16"/></>, c),
  tag:         (c) => I(<><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></>, c),
  // Resources – Teal
  user:        (c) => I(<><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></>, c),
  pieChart:    (c) => I(<><path d="M21.21 15.89A10 10 0 118 2.83"/><path d="M22 12A10 10 0 0012 2v10z"/></>, c),
  activity:    (c) => I(<><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></>, c),
  // Delivery – Blue
  folder:      (c) => I(<><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></>, c),
  clock:       (c) => I(<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>, c),
  // Billing – Yellow
  receipt:     (c) => I(<><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="12" y2="16"/></>, c),
  creditCard:  (c) => I(<><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></>, c),
  // Procurement – Coral
  factory:     (c) => I(<><path d="M2 20h20"/><path d="M6 20V8l6 4V8l6 4V4h2v16"/></>, c),
  box:         (c) => I(<><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>, c),
  // Finance – Mint
  bookOpen:    (c) => I(<><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></>, c),
  // Payroll – Gold
  banknote:    (c) => I(<><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="3"/><line x1="2" y1="10" x2="4" y2="10"/><line x1="20" y1="14" x2="22" y2="14"/></>, c),
  receiptText: (c) => I(<><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1z"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="14" y2="12"/></>, c),
  // Reports – Sky
  fileBarChart:(c) => I(<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="18" x2="8" y2="13"/><line x1="12" y1="18" x2="12" y2="11"/><line x1="16" y1="18" x2="16" y2="15"/></>, c),
  // Workflow – Cyan
  workflow:    (c) => I(<><path d="M6 3v12"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M18 9a9 9 0 01-9 9"/></>, c),
  formBuilder: (c) => I(<><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="7" y1="8" x2="17" y2="8"/><line x1="7" y1="12" x2="13" y2="12"/><line x1="7" y1="16" x2="15" y2="16"/></>, c),
  designer:    (c) => I(<><circle cx="5" cy="12" r="2"/><circle cx="19" cy="6" r="2"/><circle cx="19" cy="18" r="2"/><line x1="7" y1="11" x2="17" y2="7"/><line x1="7" y1="13" x2="17" y2="17"/></>, c),
  inbox:       (c) => I(<><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/></>, c),
  // System – Rose
  settings:    (c) => I(<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></>, c),
  database:    (c) => I(<><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></>, c),
  building:    (c) => I(<><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="9" y1="6" x2="9" y2="6.01"/><line x1="15" y1="6" x2="15" y2="6.01"/><line x1="9" y1="10" x2="9" y2="10.01"/><line x1="15" y1="10" x2="15" y2="10.01"/><line x1="9" y1="14" x2="9" y2="14.01"/><line x1="15" y1="14" x2="15" y2="14.01"/><line x1="9" y1="22" x2="9" y2="18"/><line x1="15" y1="22" x2="15" y2="18"/></>, c),
  award:       (c) => I(<><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></>, c),
  train:       (c) => I(<><rect x="4" y="3" width="16" height="14" rx="2"/><path d="M4 11h16"/><line x1="12" y1="3" x2="12" y2="11"/><line x1="8" y1="21" x2="10" y2="17"/><line x1="16" y1="21" x2="14" y2="17"/><circle cx="8.5" cy="14" r="1"/><circle cx="15.5" cy="14" r="1"/></>, c),
  mail:        (c) => I(<><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="22 6 12 13 2 6"/></>, c),
};

const MENU_SECTIONS = [
  {
    title: 'Self Service',
    icon: ICONS.home(NEON.cyan),
    items: [
      // The standalone "My Portal" page was removed; the Leave/WFH page now
      // owns the My Portal label since it's where employees actually do their
      // self-service work each day (apply leave, see balances, ack reminders).
      { path: '/ess/leave', label: 'My Portal', icon: ICONS.home(NEON.cyan) },
      { path: '/reminders', label: 'Reminders', icon: ICONS.bell ? ICONS.bell(NEON.cyan) : ICONS.calendar(NEON.cyan) },
    ]
  },
  {
    title: 'Dashboards',
    icon: ICONS.barChart(NEON.magenta),
    items: [
      { path: '/dashboard', label: 'Management', icon: ICONS.barChart(NEON.magenta) },
      { path: '/dashboard/sales', label: 'Sales', icon: ICONS.trendUp(NEON.magenta) },
      { path: '/dashboard/hr', label: 'HR', icon: ICONS.users(NEON.magenta) },
      { path: '/dashboard/finance', label: 'Finance', icon: ICONS.dollarSign(NEON.magenta) },
    ]
  },
  {
    title: 'CRM',
    icon: ICONS.target(NEON.lime),
    items: [
      { path: '/crm/leads', label: 'Leads', icon: ICONS.clipboard(NEON.lime) },
      { path: '/crm/opportunities', label: 'Opportunities', icon: ICONS.target(NEON.lime) },
      { path: '/crm/pipeline', label: 'Pipeline Board', icon: ICONS.columns(NEON.lime) }
    ]
  },
  {
    title: 'Customers',
    icon: ICONS.userGroup(NEON.orange),
    items: [
      { path: '/customers', label: 'Customer Overview', icon: ICONS.userGroup(NEON.orange) }
    ]
  },
  {
    title: 'Sales & Contracts',
    icon: ICONS.filePen(NEON.violet),
    items: [
      { path: '/estimates/rate-cards', label: 'Rate Cards', icon: ICONS.calculator(NEON.violet) },
      { path: '/estimates', label: 'Estimates', icon: ICONS.fileText(NEON.violet) },
      { path: '/proposals', label: 'Proposals', icon: ICONS.send(NEON.violet) },
      { path: '/contracts', label: 'Contracts', icon: ICONS.filePen(NEON.violet) }
    ]
  },
  {
    title: 'HCM',
    icon: ICONS.userCheck(NEON.pink),
    items: [
      { path: '/employees', label: 'Employees', icon: ICONS.userCheck(NEON.pink) },
      { path: '/employees/live', label: 'Workforce Live', icon: ICONS.userCheck(NEON.pink) },
      { path: '/letter-builder', label: 'Letter Templates', icon: ICONS.fileText(NEON.pink) },
      { path: '/org-structure', label: 'Org Structure', icon: ICONS.orgTree(NEON.pink) },
      { path: '/group-tags', label: 'Group Tags', icon: ICONS.tag(NEON.pink) },
      { path: '/recruitment', label: 'Recruitment', icon: ICONS.userPlus(NEON.pink) },
      { path: '/grades', label: 'Grades', icon: ICONS.award(NEON.pink) },
      { path: '/salary-schemas', label: 'Salary Schemas', icon: ICONS.award(NEON.pink) },
      { path: '/hcm/leave-config', label: 'Leave Configurator', icon: ICONS.calendar(NEON.pink) },
    ]
  },
  {
    title: 'Resources',
    icon: ICONS.user(NEON.teal),
    items: [
      { path: '/resources', label: 'Allocation', icon: ICONS.user(NEON.teal) },
      { path: '/resources/legacy', label: 'Legacy Allocations', icon: ICONS.user(NEON.teal) },
      { path: '/resources/bench', label: 'Bench Pool', icon: ICONS.pieChart(NEON.teal) },
      { path: '/resources/utilization', label: 'Utilization', icon: ICONS.activity(NEON.teal) },
    ]
  },
  {
    title: 'Delivery',
    icon: ICONS.folder(NEON.blue),
    items: [
      { path: '/projects', label: 'Projects', icon: ICONS.folder(NEON.blue) },
      { path: '/timesheets', label: 'Timesheets', icon: ICONS.clock(NEON.blue) },
    ]
  },
  {
    title: 'Billing',
    icon: ICONS.receipt(NEON.yellow),
    items: [
      { path: '/billing', label: 'Invoices', icon: ICONS.receipt(NEON.yellow) },
      { path: '/revenue', label: 'Revenue & Receivables', icon: ICONS.creditCard(NEON.yellow) },
    ]
  },
  {
    title: 'Procurement',
    icon: ICONS.box(NEON.coral),
    items: [
      { path: '/vendors', label: 'Vendors', icon: ICONS.factory(NEON.coral) },
      { path: '/procurement', label: 'Purchase Orders', icon: ICONS.box(NEON.coral) },
    ]
  },
  {
    title: 'Finance',
    icon: ICONS.bookOpen(NEON.mint),
    items: [
      { path: '/finance', label: 'Accounts & Journals', icon: ICONS.bookOpen(NEON.mint) },
      { path: '/accounting-guide', label: 'Accounting Guide', icon: ICONS.clipboard(NEON.mint) },
    ]
  },
  {
    title: 'Payroll',
    icon: ICONS.banknote(NEON.gold),
    items: [
      { path: '/salary', label: 'Salary', icon: ICONS.banknote(NEON.gold) },
      { path: '/reimbursements', label: 'Reimbursements', icon: ICONS.receiptText(NEON.gold) },
    ]
  },
  {
    title: 'Reports',
    icon: ICONS.fileBarChart(NEON.sky),
    items: [
      { path: '/reports', label: 'Reports', icon: ICONS.fileBarChart(NEON.sky) },
    ]
  },
  {
    title: 'Workflow',
    icon: ICONS.workflow(NEON.cyan),
    items: [
      { path: '/workflow', label: 'Cockpit', icon: ICONS.workflow(NEON.cyan) },
      { path: '/workflow/forms', label: 'Form Builder', icon: ICONS.formBuilder(NEON.cyan) },
      { path: '/workflow/designer', label: 'Designer', icon: ICONS.designer(NEON.cyan) },
      { path: '/workflow/instances', label: 'Instances', icon: ICONS.inbox(NEON.cyan) },
    ]
  },
  {
    title: 'System',
    icon: ICONS.settings(NEON.rose),
    items: [
      { path: '/admin', label: 'Administration', icon: ICONS.settings(NEON.rose) },
      { path: '/admin/integrations', label: 'Integrations', icon: ICONS.mail(NEON.rose) },
      { path: '/pricing-schemas', label: 'Pricing Schemas', icon: ICONS.calculator(NEON.rose) },
      { path: '/offices', label: 'Offices', icon: ICONS.building(NEON.rose) },
      { path: '/metadata', label: 'Metadata', icon: ICONS.database(NEON.rose) }
    ]
  }
];

/* Chevron SVG */
function ChevronIcon({ open }) {
  return (
    <svg
      width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ transition: 'transform 0.2s ease', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

export default function Sidebar({ collapsed, onToggle, currentRoute, onNavigate }) {
  /* Track which sections are expanded – auto-open section containing current route */
  const [openSections, setOpenSections] = useState(() => {
    const initial = {};
    MENU_SECTIONS.forEach((s) => {
      const hasActive = s.items.some(i => i.path === currentRoute);
      initial[s.title] = hasActive;
    });
    return initial;
  });

  /* When route changes, auto-expand the section containing the active item */
  useEffect(() => {
    MENU_SECTIONS.forEach((s) => {
      if (s.items.some(i => i.path === currentRoute)) {
        setOpenSections(prev => ({ ...prev, [s.title]: true }));
      }
    });
  }, [currentRoute]);

  function toggleSection(title) {
    if (collapsed) return; // no accordion in collapsed mode
    setOpenSections(prev => ({ ...prev, [title]: !prev[title] }));
  }

  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          Biz<span>Suite</span>
        </div>
        <button
          className="sidebar-toggle"
          onClick={onToggle}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="11 17 6 12 11 7" /><line x1="6" y1="12" x2="20" y2="12" />
            </svg>
          )}
        </button>
      </div>

      <nav className="sidebar-nav">
        {MENU_SECTIONS.map((section) => {
          const isOpen = collapsed ? false : !!openSections[section.title];
          const hasActive = section.items.some(i => i.path === currentRoute);

          return (
            <div className={`sidebar-section${hasActive ? ' has-active' : ''}`} key={section.title}>
              {/* Accordion header – section title is clickable */}
              <div
                className={`sidebar-section-title${hasActive ? ' active' : ''}`}
                onClick={() => toggleSection(section.title)}
                title={collapsed ? section.title : undefined}
              >
                <span className="section-icon">{section.icon}</span>
                <span className="section-label">{section.title}</span>
                {!collapsed && <span className="section-chevron"><ChevronIcon open={isOpen} /></span>}
              </div>

              {/* Submenu items – hidden when collapsed or accordion closed */}
              <div className={`sidebar-submenu${isOpen ? ' open' : ''}`}>
                {section.items.map((item) => {
                  const isActive = currentRoute === item.path;
                  const isDisabled = item.disabled;

                  return (
                    <div
                      key={item.label}
                      className={`sidebar-item${isActive ? ' active' : ''}${isDisabled ? ' disabled' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isDisabled && item.path) onNavigate(item.path);
                      }}
                      title={collapsed ? item.label : undefined}
                    >
                      <span className="icon">{item.icon}</span>
                      <span className="label">{item.label}</span>
                      {isDisabled && <span className="coming-soon">Soon</span>}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
